import React from 'react'

import classes from './skip-link.module.scss'

export const SkipLink = () => (
  <a className={classes.link} href="#maincontent">
    Skip to main content
  </a>
)
